import {
    FETCH_AUTH_TEST, FETCH_AUTH_TEST_SUCCESS, FETCH_AUTH_TEST_FAILURE,
    FETCH_LOGIN, FETCH_LOGIN_SUCCESS, FETCH_LOGIN_FAILURE,
    FETCH_LOGOUT, FETCH_LOGOUT_SUCCESS, FETCH_LOGOUT_FAILURE,
    FETCH_FORGOT_PASSWORD, FETCH_FORGOT_PASSWORD_SUCCESS, FETCH_FORGOT_PASSWORD_FAILURE,
    FETCH_RESET_PASSWORD, FETCH_RESET_PASSWORD_SUCCESS, FETCH_RESET_PASSWORD_FAILURE, CLEAR_RESET_PASSWORD_FORM, UPDATE_RESET_PASSWORD_FORM,
    FETCH_NEW_USER, FETCH_NEW_USER_SUCCESS, FETCH_NEW_USER_FAILURE,
    CLEAR_ERROR, UPDATE_AUTH, UPDATE_CREDENTIALS, CLEAR_USER, EMPTY_AUTH, UPDATE_USER, UPDATE_USER_ADMIN_EMAIL, UPDATE_USER_ROLE
} from './constants';
import { PATHS } from 'utils/paths';

const fetchLogin = () => ({
    type: FETCH_LOGIN
});

const fetchLoginSuccess = () => ({
    type: FETCH_LOGIN_SUCCESS
});

const fetchLoginFailure = (error) => ({
    type: FETCH_LOGIN_FAILURE,
    error
});

const fetchLogout = () => ({
    type: FETCH_LOGOUT
});

const fetchLogoutSuccess = () => ({
    type: FETCH_LOGOUT_SUCCESS
});

const fetchLogoutFailure = (error) => ({
    type: FETCH_LOGOUT_FAILURE,
    error
});

const fetchAuthTest = () => ({
    type: FETCH_AUTH_TEST
});

const fetchAuthTestSuccess = () => ({
    type: FETCH_AUTH_TEST_SUCCESS
});

const fetchAuthTestFailure = (error) => ({
    type: FETCH_AUTH_TEST_FAILURE,
    error
});

export const updateAuth = (data) => ({
    type: UPDATE_AUTH,
    data
});

export const updateCredentials = (data) => ({
    type: UPDATE_CREDENTIALS,
    data
});

export const updateUser = (data) => ({
    type: UPDATE_USER,
    data
});

const updateUserRole = (data) => ({
    type: UPDATE_USER_ROLE,
    data
});

const updateUserAdminEmail = (data) => ({
    type: UPDATE_USER_ADMIN_EMAIL,
    data
});

const fetchForgotPassword = () => ({
    type: FETCH_FORGOT_PASSWORD
});

const fetchForgotPasswordSuccess = () => ({
    type: FETCH_FORGOT_PASSWORD_SUCCESS
});

const fetchForgotPasswordFailure = (error) => ({
    type: FETCH_FORGOT_PASSWORD_FAILURE,
    error
});

const fetchResetPassword = () => ({
    type: FETCH_RESET_PASSWORD
});

const fetchResetPasswordSuccess = () => ({
    type: FETCH_RESET_PASSWORD_SUCCESS
});

const fetchResetPasswordFailure = (error) => ({
    type: FETCH_RESET_PASSWORD_FAILURE,
    error
});

const fetchNewUser = () => ({
    type: FETCH_NEW_USER
});

const fetchNewUserSuccess = () => ({
    type: FETCH_NEW_USER_SUCCESS
});

const fetchNewUserFailure = (error) => ({
    type: FETCH_NEW_USER_FAILURE,
    error
});

export const clearResetPasswordForm = () => ({
    type: CLEAR_RESET_PASSWORD_FORM
});

export const updateResetPasswordForm = (data) => ({
    type: UPDATE_RESET_PASSWORD_FORM,
    data
});

export const clearError = () => ({
    type: CLEAR_ERROR
});

export const clearUser = () => ({
    type: CLEAR_USER
});

export const emptyAuth = () => ({
    type: EMPTY_AUTH
});



/**
 *  ASYNC ACTIONS
 */

export const authTest = (showError, callback) => (dispatch) => {
    dispatch(fetchAuthTest());

    let config = {
        method: 'GET',
        redirect: 'follow',
        mode: 'cors',
        credentials: 'include',
        headers: new Headers({
            'Accept': '*/*'
        })
    };

    //console.log('in authTest from login', showError);

    fetch(PATHS.auth.authTest(), config)
        .then((response) => {
            //console.log('content type', response.headers.get('content-type'))
            if(response.headers.get('content-type') === 'text/plain') {
                if(callback) {
                    callback(true);
                }
            } else {
                let error = {};
                if(showError) {
                    error.friendlyMessage = 'Please sign in to continue';
                }
                dispatch(fetchAuthTestFailure(error));
                if(callback) {
                    callback(false);
                }
            }
        })
        .catch((error) => {
            if(showError === true) {
                error.friendlyMessage = 'Please sign in to continue.';
                dispatch(fetchAuthTestFailure(error));
            } else {
                dispatch(fetchAuthTestFailure({}));
            }
        });
};

export const getLoggedInUser = (callback, hasAccess) => (dispatch) => {

    let config = {
        method: 'GET',
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors',
        headers: new Headers({
            'Accept': 'text/plain'
        })
    };

    //Keep track of number of responses.
    let responses = 0;

    fetch(PATHS.users.getUser.loggedInUserID(), config)
        .then((response) => {
            return response.text();
        })
        .then((loggedInUserID) => {
            dispatch(fetchLoginSuccess());
            //console.log('loggedInUserID', loggedInUserID)
            config.headers = new Headers({'Accept': 'application/json'});
            fetch(PATHS.users.getUser.byID(loggedInUserID, false), config)
                .then((response) => {
                    return response.json();
                })
                .then((user) => {
                    responses++;
                    dispatch(updateUser(user));
                    if(responses === 3) {
                        setTimeout(() => {
                            dispatch(fetchAuthTestSuccess());
                        }, 2000);
                        setTimeout(() => {
                            if (callback) {
                                callback(hasAccess);
                            }
                        }, 1);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(fetchAuthTestFailure(error));
                });
        })
        .catch((error) => {
            console.log(error);
            dispatch(fetchAuthTestFailure(error));
        });

    let adminConfig = {
        method: 'GET',
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors',
        headers: new Headers({
            'Accept': 'text/plain'
        })
    };

    fetch(PATHS.auth.adminTest(), adminConfig)
        .then((response) => {
            return response.text();
        })
        .then((role) => {
            if(role.indexOf(':') >= 0){
                role = role.split(':')[0];
            }
            responses++;
            dispatch(updateUserRole(role));
            if(responses === 3) {
                setTimeout(() => {
                    dispatch(fetchAuthTestSuccess());
                }, 2000);
                setTimeout(() => {
                    if (callback) {
                        callback(hasAccess);
                    }
                }, 1);
            }
        });

    fetch(PATHS.auth.myAdmin(), adminConfig)
        .then((response) => {
            return response.text();
        })
        .then((adminEmail) => {
            responses++;
            dispatch(updateUserAdminEmail(adminEmail));
            if(responses === 3) {
                setTimeout(() => {
                    dispatch(fetchAuthTestSuccess());
                }, 2000);
                //console.log('hasAccess in getLoggedInUser', hasAccess);
                setTimeout(() => {
                    if (callback) {
                        callback(hasAccess);
                    }
                }, 1);
            }
        });
};

export const login = (callback) => (dispatch, getState) => {
    dispatch(fetchLogin());

    let credentials = getState().auth.credentials;
    let body = `j_username=${encodeURIComponent(credentials.userName).replace('%20', '+')}&j_password=${encodeURIComponent(credentials.password).replace(' ', '+')}`;

    let config = {
        method: 'POST',
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': '*/*'
        }),
        body: body
    };

    fetch(PATHS.auth.login(), config)
        .then((response) => {
            //console.log('response', response);
            dispatch(authTest(true, (hasAccess) => {
                if(hasAccess === true) {
                    //console.log('getting logged in user');
                    dispatch(getLoggedInUser(callback, hasAccess))
                } else {
                    dispatch(fetchLoginFailure());
                    if(callback) {
                        callback(hasAccess);
                    }
                }
            }));
        })
        .catch((error) => {
            //TODO: Error message
        });
};

export const logout = (callback) => (dispatch) => {
    dispatch(fetchLogout());

    let config = {
        method: 'GET',
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors'
    };

    fetch(PATHS.auth.logout(), config)
        .then(() => {
            dispatch(fetchLogoutSuccess());
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch(fetchLogoutFailure(error));
        })
};

export const postForgotPassword = (callback) => (dispatch, getState) => {
    dispatch(fetchForgotPassword());
    let userName = getState().auth.credentials.userName;
    let config = {
        method: 'POST',
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }),
        body: JSON.stringify({userName})
    };

    fetch(PATHS.auth.forgotPassword(), config)
        .then(() => {
            dispatch(fetchForgotPasswordSuccess());
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            error.friendlyMessage = 'There was an error resetting your password. Please try again later.';
            console.log(error);
            dispatch(fetchForgotPasswordFailure(error));
        });
};

export const postPasswordReset = (callback) => (dispatch, getState) => {
    dispatch(fetchResetPassword());
    let auth = getState().auth;
    let config = {
        method: 'POST',
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }),
        body: JSON.stringify({
            code: auth.resetPasswordForm.code,
            password: auth.resetPasswordForm.password,
            userName: auth.credentials.userName
        })
    };

    fetch(PATHS.auth.forgotPassword(), config)
        .then(() => {
            dispatch(fetchResetPasswordSuccess());
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            error.friendlyMessage = 'There was an error resetting your password. Please try again later.';
            console.log(error);
            dispatch(fetchResetPasswordFailure(error));
        });
};

export const postSignup = (callback) => (dispatch, getState) => {
    dispatch(fetchNewUser());
    let user = JSON.parse(JSON.stringify(getState().auth.user));
    delete user.password2;

    let config = {
        method: 'POST',
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }),
        body: JSON.stringify(user)
    };

    fetch(PATHS.auth.signup(), config)
        .then((response) => {
            if(response.status === 200) {
                return response.text();
            } else {
                let error = new Error('There was an error signing up. Please try again later.');
                error.response = response;
                error.status = response.status;
                throw error;
            }
        })
        .then((text) => {
            if(text === 'duplicate') {
                let error = new Error();
                error.message = 'This email is already in use. Please sign up with another email address or contact your Account Administrator.';
                throw error;
            } else {
                dispatch(fetchNewUserSuccess());
                if (callback) {
                    callback();
                }
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch(fetchNewUserFailure(error));
        });
};



// WEBPACK FOOTER //
// ./src/containers/AuthPages/store/actions.js